import React from 'react'

const DownloadSidebarIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected ? 'var(--forbrand-primary)' : '#111113'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        fill={fillColor}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        data-iconid="code-download-outline"
        data-svgname="Code download outline"
      >
        <g data-name="Layer 2">
          <g data-name="code-download">
            <rect
              width="24"
              height="24"
              transform="rotate(90 12 12)"
              opacity="0"
            ></rect>

            <path d="M4.29 12l4.48-5.36a1 1 0 1 0-1.54-1.28l-5 6a1 1 0 0 0 0 1.27l4.83 6a1 1 0 0 0 .78.37 1 1 0 0 0 .78-1.63z"></path>

            <path d="M21.78 11.37l-4.78-6a1 1 0 0 0-1.56 1.26L19.71 12l-4.48 5.37a1 1 0 0 0 .13 1.41A1 1 0 0 0 16 19a1 1 0 0 0 .77-.36l5-6a1 1 0 0 0 .01-1.27z"></path>

            <path d="M15.72 11.41a1 1 0 0 0-1.41 0L13 12.64V8a1 1 0 0 0-2 0v4.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l3 3A1 1 0 0 0 12 16a1 1 0 0 0 .69-.28l3-2.9a1 1 0 0 0 .03-1.41z"></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

export default DownloadSidebarIcon
